import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'

export const APP_NAME = 'Empower';
export const API_BASE_URL = env.API_ENDPOINT_URL
export const API_FILE_PATH_URL = env.API_FILE_PATH_URL
export const RO_FILE_PATH_URL = env.RO_FILE_PATH_URL
export const APP_PREFIX_PATH = 'frontend';
export const AUTH_PREFIX_PATH = 'frontend';
export const REDIRECT_URL_KEY = 'redirect';
export const UNAUTHENTICATED_ENTRY = '/login'
//export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/default`;

// const { 
// 	navType, 
// 	sideNavTheme, 
// 	navCollapsed,
// 	topNavColor, 
// 	headerNavColor, 
// 	locale, 
// 	currentTheme, 
// 	direction
// } = useSelector(state => state.theme)

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'en',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#3e82f7',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: "light",
	direction: DIR_LTR,
	blankLayout: false
};
